import React, { useState } from 'react';
import { Sliders, DollarSign } from 'lucide-react';
import { Filters } from '../../types/equipment';

interface SearchFiltersProps {
  onFilterChange: (filters: Filters) => void;
}

export const SearchFilters: React.FC<SearchFiltersProps> = ({ onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 50]);

  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (e.target.id === 'min-price') {
      setPriceRange([value, priceRange[1]]);
    } else {
      setPriceRange([priceRange[0], value]);
    }
  };
  
  
  const applyFilters = () => {
    onFilterChange({
      priceRange,
    });
    setIsOpen(false);
  };
  
  return (
    <div className="relative z-10 w-2/5">
      <div className="flex justify-center items-center p-4">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center space-x-2 bg-white border border-gray-300 rounded-full px-4 py-2 shadow-sm hover:shadow-md transition-shadow"
        >
          <Sliders size={16} className="text-gray-500" />
          <span>Filtros</span>
        </button>
      </div>
      
      {isOpen && (
        <div className="absolute left-0 right-0 mt-1 bg-white rounded-lg shadow-xl border border-gray-200 p-4 fade-in">
          <div className="space-y-6">
            <div>
              <div className="flex items-center mb-4">
                <DollarSign size={18} className="text-gray-700 mr-2" />
                <h3 className="font-medium text-gray-800">Rango de precio</h3>
              </div>
              <div className="flex space-x-4">
                <div className="w-1/2">
                  <label htmlFor="min-price" className="block text-sm text-gray-600 mb-1">
                    Precio mínimo (€)
                  </label>
                  <input
                    type="number"
                    id="min-price"
                    min="0"
                    max={priceRange[1]}
                    value={priceRange[0]}
                    onChange={handlePriceChange}
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  />
                </div>
                <div className="w-1/2">
                  <label htmlFor="max-price" className="block text-sm text-gray-600 mb-1">
                    Precio máximo (€)
                  </label>
                  <input
                    type="number"
                    id="max-price"
                    min={priceRange[0]}
                    value={priceRange[1]}
                    onChange={handlePriceChange}
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  />
                </div>
              </div>
            </div>
            
            <div className="border-t border-gray-200 pt-4 flex justify-between">
              <button
                onClick={() => {
                  setPriceRange([0, 50]);
                }}
                className="text-gray-700 hover:text-gray-900"
              >
                Limpiar filtros
              </button>
              <button
                onClick={applyFilters}
                className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700"
              >
                Aplicar filtros
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};